// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundles/" + __webpack_require__.h() + "/" + (chunkId === 1040 ? "unhomoglyph_data" : chunkId) + ".js";
};